export default {"src":"/_next/static/media/dateForm.d7b73f51.svg","height":18,"width":16};